import { Pipe, PipeTransform } from '@angular/core';
import { FINANCIAL_OCCURRENCE_TYPE } from '@constants/financial-occurrence-type.constants';
import { ConstantModel } from '@core/models/outros/constant.model';

@Pipe({name: 'financialOccurrenceTypePipe'})
export class FinancialOccurrenceTypePipe implements PipeTransform {

  transform(value: string): string {
    let type: ConstantModel = FINANCIAL_OCCURRENCE_TYPE.find(x => x.enum == value);
    return type ? type.descricao : '-'
  }
}
